import HotelCard from "./HotelCard";
import { useState } from "react";
import ImageCarouselModal from "./ImageCarouselModal";

function TrendingHotels({ hotels }) {
  const [openPhotos, setOpenPhotos] = useState(false);
  const [currentPhotos, setCurrentPhotos] = useState([]);

  const openGallery = (hotel) => {
    // Use photos from hotel data (persisted in DB) or fallback to single imageUrl
    const photos = hotel.photos && hotel.photos.length > 0 ? hotel.photos : [hotel.imageUrl];
    setCurrentPhotos(photos);
    setOpenPhotos(true);
  };

  const closeGallery = () => {
    setOpenPhotos(false);
    setCurrentPhotos([]);
  };

  return (
    <section id="trending-hotels" className="bg-white py-24">

      <div className="max-w-7xl mx-auto px-4">

        {/* Section Header */}
        <div className="text-center mb-12">

        <h2 className="text-4xl md:text-5xl font-luxury font-semibold text-luxury-dark mb-6 tracking-wide">
          <span className="brand-orange-text">Hotels</span> Near You
        </h2>


          <div className="w-16 h-1 brand-orange-bg mx-auto mt-4 mb-6 rounded-full"></div>

          <p className="text-gray-600 text-sm md:text-base">
            Discover hotels near your location with verified photo, modern amenities, and comfortable stays for every budget.
          </p>

        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {hotels.slice(0, 4).map((hotel) => (
            <HotelCard key={hotel.id} hotel={hotel} onOpenGallery={openGallery} />
          ))}
        </div>

        {openPhotos && (
          <ImageCarouselModal photos={currentPhotos} initialIndex={0} onClose={closeGallery} />
        )}

      </div>

    </section>
  );
}

export default TrendingHotels;
